export enum Types {
    Order = 1,
    Product = 2
}

export enum TicketType {
    Order = 'Orders',
    Product = 'Products',
    Email_to_Ticket = 'Email to Ticket',
    Account = 'Account',
    Account_Issues = 'Account Issues',
    Applications = 'Applications',
    Billing_Issues = 'Billing Issues',
    Bonus = 'Bonus',
    Bonus_Re_issue = 'Bonus Re-issue',
    Complaints = 'Complaints',
    Compliance = 'Compliance',
    Delivery = 'Delivery',
    Duplicate_Email = 'Duplicate Email',
    Events = 'Events',
    Finance = 'Finance',
    Notes = 'Notes',
    Services = 'Services',
    UK_Finance = 'UK_Finance',
    Orders_related_ticket = 'Orders related ticket',
    Argentina_Operating_country_name = 'Argentina Operating country name',
    FLP360_Reports_In_Screen_Feedback = 'FLP360 Reports In-screen Feedback'
}

export enum SubtypesEnums {
    Dispute = 96,
    Cancel = 95,
    Cancel_Order = 1
}

export enum DisputeTypesEnums{
    Dispute_Individual_Order = 61,
    Dispute_Total_Order = 60
}

export enum Priority {
    Medium = 9,
    High = 10
}

export enum SourceType {
    Phone = 6,
    Email = 7,
    Online_Form = 64
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/ticket-type.enum.ts